import React from 'react';
import './Footer.css';

// Simple footer component displaying company branding
function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <a href="https://claiva.com/" target="_blank" rel="noopener noreferrer">TravelFind by Claiva - AI-powered deal validation and conversational agent</a>
      </div>
    </footer>
  );
}

export default Footer;
